import { Component, OnInit, ViewChild, Directive, Input } from '@angular/core';
import { siniestralidadService } from "./siniestralidad.service";
import { ClienteLogin, ClienteXCiudad,ConsultaCliente } from "../../login/cliente_login";
import { correctHeight, detectBody } from "../../../app.helpers";
import { SessionStorageService } from "ngx-webstorage/dist/services";
import { HandleError } from "../../../components/common/utils/handleError.component";
import { Router } from '@angular/router';
import { SessionTokenService } from "../../../components/common/utils/sessionToken.service";
import { DatosGeneralesEntity } from "../entities/datos_generales_entity";
import { ModalComponent } from "ng2-bs3-modal/ng2-bs3-modal";
import { PolizaEntity,BusquedaSiniestralidad ,TitularVam} from "../entities/polizas_cliente_entity";
import { AplicacionesTransporteComponent } from "../aplicacionesTransporte/aplicaciones-transporte.component";
import { ExclusionVehiculos } from "../solicitudes/solicitud-vehiculos.component";
import { ExclusionVehiculosService } from "../solicitudes/solicitud-vehiculos.service";
import { ExclusionEquipos } from "../solicitudes/solicitud-equipo.component";
import { ExclusionEquiposService } from "../solicitudes/solicitud-equipo.service";
import { PolizasVencidasNoLiberadasService } from "../fianzas/polizasVencidasNoLiberadas/polizas-vencidasnoLiberadas.service";
import { PolizasVencidasNoLiberadasEntity } from "../fianzas/entities/polizas-vencidasnoLiberadas_entity";
import { ComboBox, ObjMultiSelect } from "../../../components/common/utils/combobox";
import { ClienteVAM, UsuarioVamTit } from '../../login/cliente_login';
import { ConsultarUsuarioVAM } from '../../../components/common/utils/consultarUsuarioVAM';
import { CalendarFechaNac } from "../../../components/common/utils/calendarFechaNacParametros";
import { PolizaVAM, SiniestralidadClientes, ResumenSiniestralidad, SiniestralidadMaternidad, RankingDiagnosticos, ProveedoresSiniestralidad,BusquedaFacturacion } from '../entities/vam_entities';
import { IMultiSelectSettings, IMultiSelectTexts } from 'angular-2-dropdown-multiselect';

const swal = require("sweetalert2");

declare var jQuery: any;
@Component({
    selector: 'siniestralidad',
    providers: [],
    templateUrl: 'siniestralidad.template.html'

})

export class siniestralidad extends CalendarFechaNac implements OnInit {
    usuario: ClienteLogin;
    polizas: PolizaEntity[];
    public showLoader: string;
    opcion: number;
    polizaContratada: PolizaEntity;
    show: boolean;
    showVeh: boolean;
    showEqu: boolean;
    showOtr: boolean;
    showRed: boolean;
    showPlanes: boolean;
    showListados: boolean;
    showSiniestralidad: boolean;
    showMovimientos: boolean;
    banderaFianza: boolean;
    banderaCredito: boolean;
    opciones: boolean;
    polizaDetalle: PolizasVencidasNoLiberadasEntity;
    detallePolizas1: PolizasVencidasNoLiberadasEntity[];
    @ViewChild('detallePolizas')
    modal: ModalComponent;
    poliza: string;
    rutaMovimientos: boolean;
    opcionSeleccionada: number = 0;
    rowSelect: number;
    showSolicitudes: boolean;
    opcionCliente: number;
    comboClientes: ComboBox[];
    busqueda: BusquedaSiniestralidad;
    opcionBusqueda: number;
    codigoGrupo: number;
    codigoCliente: number;
    codigounidad: number;
    usuarioVam: UsuarioVamTit;
    titular:TitularVam;
    usuarioempresaretrive: ClienteXCiudad;
    public resumen;
    showTab: boolean;
    public DiagnosticoPorReclamo;
    public DetalleProveedorXReclamo;
    public DetalleSinMaternidad;
    public TitularesMayorValor;
    public TitularesMayorNumeroReclamos;
    public DetalleTitularesMayorValor;
    public DetalleMayorNumeroReclamos;
    public DetalleProveedorXValor;
    public top;
     cabecera : PolizaVAM;
     detalles : PolizaEntity;
    CodigoCiudad: number;
    comboTipoNegocio: ComboBox[];
    comboRamos: ComboBox[];
    comboAseguradora:ComboBox[];
    comboPlanes:ComboBox[];
    public RamosReporte?: ObjMultiSelect[];
    
    mySettings: IMultiSelectSettings = {
        enableSearch: true,
        buttonClasses: 'btn btn-default btn-block multiselect',
        dynamicTitleMaxItems: 1,
        displayAllSelectedText: true,
        containerClasses: 'multiselect'
    
      };
      myTexts: IMultiSelectTexts = {
        checkAll: 'Seleccionar todos',
        uncheckAll: 'Deseleccionar todos',
        checked: 'seleccionado',
        checkedPlural: 'seleccionados',
        searchPlaceholder: 'Buscar',
        defaultTitle: 'Selecccionar',
        allSelected: 'Todos seleccionados',
      };
    constructor(
        private siniestralidadService: siniestralidadService,
        private exclusionVehiculosService: ExclusionVehiculosService,
        private router: Router,
        private sessionTokenService: SessionTokenService,
        private handleError: HandleError,
        public sesionStorageService: SessionStorageService,
        public polizasLiberadasService: PolizasVencidasNoLiberadasService,
        private consultarVAM: ConsultarUsuarioVAM) { 
            super();
            this.resumen = new ResumenSiniestralidad();
            this.DiagnosticoPorReclamo = new RankingDiagnosticos();
            this.DetalleProveedorXReclamo = new ProveedoresSiniestralidad();
            this.showTab = false;
            this.cabecera=new PolizaVAM();
            this.detalles=new PolizaEntity();
         }

    ngOnInit() {
        this.opcionCliente = 1;
        this.codigoGrupo = 0;
        this.opcionBusqueda = 1;
        //Inicializando busqueda
      
        try {
            this.usuarioempresaretrive = JSON.parse(this.sesionStorageService.retrieve("usuarioempresa"));
        } catch (e) {
            this.usuarioempresaretrive = this.sesionStorageService.retrieve("usuarioempresa");
        }
       let cliente = this.usuarioempresaretrive.CodigoCliente;
       this.CodigoCiudad= this.usuarioempresaretrive.Ciudad;
        console.log(this.usuarioempresaretrive);
        this.busqueda = new BusquedaSiniestralidad();
        this.busqueda.CodigoPlan = 0;
        this.busqueda.CodigoRamo = "0";
        this.busqueda.CodigoCiudad =  this.CodigoCiudad;
        this.busqueda.CodigoUnidad = Number(sessionStorage.getItem("unidad"));
        this.busqueda.TopRegistros = 10;
        this.busqueda.TipoFecha = 1;
        this.busqueda.CodigoTipoNegocio=0;
        this.busqueda.CodigoAseguradora=0;
        this.showSiniestralidad = false;

        if ((cliente != null && Number(cliente) > 0)) {
            this.showLoader = "sk-loading";
            
            if (cliente != null) {
                this.codigoCliente = Number(cliente);
                this.busqueda.CodigoCliente = this.codigoCliente;
            }

            let consultaCliente = new ConsultaCliente();
            consultaCliente.Cliente = this.codigoCliente;
            consultaCliente.Grupo = this.codigoGrupo;
            consultaCliente.Ciudad = this.CodigoCiudad;
            consultaCliente.Unidad = Number(sessionStorage.getItem("unidad"));
            this.siniestralidadService.getClientes(consultaCliente).subscribe(infoPantalla => {
                this.comboClientes = infoPantalla;
                this.showLoader = "";
                this. consultarTipoDeNegocio();
                this.consutarRamos();
                this.consultarGrupos(consultaCliente);
                this.consultarDatosCliente(consultaCliente);

               console.log(infoPantalla);
                
            }, error => {
                this.showLoader = "";
                swal({
                    title: 'Error al cargar los clientes',
                    text: error,
                    type: 'error',
                    confirmButtonColor: '#A14950',
                    confirmButtonText: 'Aceptar'
                })
            });
        }
        else {
            swal({
                title: 'Alerta',
                text: 'Seleccione un cliente o grupo para consultar su siniestralidad.',
                type: 'warning',
                confirmButtonColor: '#A14950',
                confirmButtonText: 'Aceptar'
            })
        }

    }


    rutaParaConsultaPolizas(segmento: number, segmentoAlterno: number) {
        // this.polizasContratadasService.consultaPolizasContratadas(segmento, segmentoAlterno)
        //     .subscribe(
        //     polizas => {
        //         this.polizas = polizas;
        //         this.showLoader = "";
        //     },
        //     error => { this.handleError.redirectUrl(error); }
        //     );
    }

    consultarDetalle() {
        this.showLoader = "sk-loading"
        this.showTab = false;

        this.detalles.CodigoCiudad =  this.CodigoCiudad;
        this.detalles.CodigoCliente = this.busqueda.CodigoCliente;
        this.detalles.CodigoUnidad = this.codigounidad;
        this.detalles.CodigoGrupo =this.codigoGrupo;
        this.detalles.CodigoRamo=this.busqueda.CodigoRamo;
       // this.cabecera.FechaDesde=this.busqueda.FechaDesde;
       // this.cabecera.FechaHasta=this.busqueda.FechaHasta;
        this.cabecera.TipoFecha=this.busqueda.TipoFecha;
        this.cabecera.TopRegistros=this.busqueda.TopRegistros;
        this.cabecera.Poliza=this.detalles;
        this.cabecera.Ramos=this.busqueda.Ramos;
        this.detalles.CodigoTipoNegocio=this.busqueda.CodigoTipoNegocio;
        this.detalles.Opcion=this.opcionCliente;
        
       //this.cabecera.Poliza=this.detalles;
       //console.log(this.codigoGrupo);
        this.siniestralidadService.consultaSiniestralidadVAMEmpresa(this.cabecera).subscribe(
            result => {
                if (result.Clientes != null || result.DetalleDiagnostico != null || result.DiagnosticoXReclamo != null || result.Maternidad != null || result.ProveedorXReclamo != null || result.ProveedorXValor != null || result.RankingTitulares != null || result.Resumen != null) {
                    this.showTab = true;
                    this.resumen = result.Resumen;
                    this.DiagnosticoPorReclamo = result.DiagnosticoXReclamo;//aqui
                     this.DetalleSinMaternidad = result.Maternidad;//aqui
                     this.TitularesMayorValor = result.RankingTitulares.TitularesMayorValor;//aqui
                     this.TitularesMayorNumeroReclamos = result.RankingTitulares.TitularesMayorNumeroReclamos;//aqui
                     this.DetalleTitularesMayorValor = result.RankingTitulares.DetalleTitularesMayorValor;//aqui
                    this.DetalleMayorNumeroReclamos = result.RankingTitulares.DetalleTitularesMayorNumeroReclamos;
                    this.DetalleSinMaternidad = result.Maternidad;//aqui
                     this.DetalleProveedorXReclamo = result.ProveedorXReclamo;
                     this.DetalleProveedorXValor = result.ProveedorXValor;
                     this.top = this.cabecera.TopRegistros;
                     this.showLoader = "";
                }else{
                    swal({
                        title: 'No existe información',
                        text: 'El reporte de siniestralidad no se encuentra disponible',
                        type: 'info'
                    })
                }
               
            },
            error => {
                this.handleError.redirectUrl(error);
                this.showLoader = "";
            }
        );
    }

   

     onCambiarCliente() {
        this.showSiniestralidad = false;
        this.busqueda.CodigoCliente = 0;
        this.busqueda.CodigoGrupo = 0;
        this.busqueda.CodigoRamo = "0";
    console.log(this.opcionCliente)
        if (this.opcionCliente == 2) {
            this.busqueda.CodigoGrupo = this.codigoGrupo;
            //this.consutarRamos();
        } else {
            this.busqueda.CodigoGrupo = 0;
        }
    }

    set dateFechaDesde(e) {
        this.cabecera.FechaDesde = new Date(e);
    }

    get dateFechaDesde() {
        if (this.cabecera.FechaDesde != undefined) {
            try {
                let a = this.cabecera.FechaDesde.toISOString().substring(0, 10);
                var b = a.split("-");
                return b[2] + "/" + b[1] + "/" + b[0];
            } catch (e) {
                let a = this.cabecera.FechaDesde.toString().substring(0, 10);
                let b = a.split("-");
                return b[2] + "/" + b[1] + "/" + b[0];
            }
        }
    }
    set dateFechaHasta(e) {
        this.cabecera.FechaHasta = new Date(e);
    }

    get dateFechaHasta() {
        if (this.cabecera.FechaHasta != undefined) {
            try {
                let a = this.cabecera.FechaHasta.toISOString().substring(0, 10);
                let b = a.split("-");
                return b[2] + "/" + b[1] + "/" + b[0];
            } catch (e) {
                let a = this.cabecera.FechaHasta.toString().substring(0, 10);
                let b = a.split("-");
                return b[2] + "/" + b[1] + "/" + b[0];
            }
        }
    }
    consultarTipoDeNegocio() {
        if (this.codigoCliente != 0 || this.codigoGrupo != 0) {
            this.showLoader = "sk-loading";
            let busquedaFacturacion=new BusquedaFacturacion();
            busquedaFacturacion.CodigoCiudad=this.CodigoCiudad;
            busquedaFacturacion.CodigoCliente=this.codigoCliente
            busquedaFacturacion.CodigoGrupo=this.codigoGrupo;
            this.siniestralidadService.getTipoNegocio(busquedaFacturacion).subscribe(data => {
                this.comboTipoNegocio = data;
                this.showLoader = "";
            }, error => {
                this.showLoader = "";
                swal({
                    title: 'Error al cargar los clientes',
                    text: error,
                    type: 'error',
                    confirmButtonColor: '#A14950',
                    confirmButtonText: 'Aceptar'
                })
            });
        }

    }
    consutarRamos() {
        this.showLoader = "sk-loading";
        this.showSiniestralidad = false;
        this.busqueda.CodigoRamo = "0";
        this.busqueda.CodigoTipoNegocio=0;
        this.busqueda.CodigoAseguradora=0;
        let busqueda=new BusquedaSiniestralidad();
        busqueda.CodigoCiudad=this.CodigoCiudad;
        busqueda.CodigoCliente=this.busqueda.CodigoCliente
        busqueda.CodigoGrupo=this.codigoGrupo;
        this.RamosReporte = new Array<ObjMultiSelect>();
        this.siniestralidadService.getRamos(busqueda).subscribe(ramos => {
            this.RamosReporte = ramos;
            this.showLoader = "";
        }, error => {
            this.showLoader = "";
            swal({
                title: 'Error al cargar los ramos del cliente',
                text: error,
                type: 'error',
                confirmButtonColor: '#A14950',
                confirmButtonText: 'Aceptar'
            })
        });
    }
    consultarAseguradora() {
        if (this.busqueda.CodigoTipoNegocio != 0 || (this.busqueda.Ramos != null || this.busqueda.Ramos != undefined)) {
            this.showLoader = "sk-loading";
            this.siniestralidadService.getAseguradora(this.busqueda).subscribe(data => {
                this.comboAseguradora = data;
                this.showLoader = "";
            }, error => {
                this.showLoader = "";
                swal({
                    title: 'Error al cargar los aseguradoras',
                    text: error,
                    type: 'error',
                    confirmButtonColor: '#A14950',
                    confirmButtonText: 'Aceptar'
                })
            });
        }

    }
    consultarGrupos(ConsultaCliente: ConsultaCliente) {
       
        if (ConsultaCliente != null || ConsultaCliente != undefined) {
            this.showLoader = "sk-loading";
            this.siniestralidadService.getGrupo(ConsultaCliente).subscribe(data => {
                this.codigoGrupo = data;
                console.log(Number(data));
                console.log(data);
                this.showLoader = "";
            }, error => {
                this.showLoader = "";
                swal({
                    title: 'Error al cargar el grupos',
                    text: error,
                    type: 'error',
                    confirmButtonColor: '#A14950',
                    confirmButtonText: 'Aceptar'
                })
            });
        }

    }
    consutarPlanes() {
        this.showLoader = "sk-loading";
        this.siniestralidadService.getPlanes(this.busqueda).subscribe(planes => {
            this.comboPlanes = planes;
            this.showLoader = "";
        }, error => {
            this.showLoader = "";
            swal({
                title: 'Error al cargar los clientes',
                text: error,
                type: 'error',
                confirmButtonColor: '#A14950',
                confirmButtonText: 'Aceptar'
            })
        });
    }
    consultarDatosCliente(ConsultaCliente: ConsultaCliente) {
       
        if (ConsultaCliente != null || ConsultaCliente != undefined) {
            this.showLoader = "sk-loading";
            this.siniestralidadService.getDatosCliente(ConsultaCliente).subscribe(data => {
                this.codigounidad = data.Unidad;
                this.showLoader = "";
            }, error => {
                this.showLoader = "";
                swal({
                    title: 'Error al cargar el grupos',
                    text: error,
                    type: 'error',
                    confirmButtonColor: '#A14950',
                    confirmButtonText: 'Aceptar'
                })
            });
        }

    }
    exportarSiniestralidad() {
        this.showLoader = "sk-loading"
        this.showTab = false;

        this.detalles.CodigoCiudad =  this.CodigoCiudad;
        this.detalles.CodigoCliente = this.busqueda.CodigoCliente;
        this.detalles.CodigoUnidad = this.codigounidad;
        this.detalles.CodigoGrupo =this.codigoGrupo;
        this.detalles.CodigoRamo=this.busqueda.CodigoRamo;
       // this.cabecera.FechaDesde=this.busqueda.FechaDesde;
       // this.cabecera.FechaHasta=this.busqueda.FechaHasta;
        this.cabecera.TipoFecha=this.busqueda.TipoFecha;
        this.cabecera.TopRegistros=this.busqueda.TopRegistros;
        this.cabecera.Poliza=this.detalles;
        this.detalles.CodigoTipoNegocio=this.busqueda.CodigoTipoNegocio;
        this.detalles.Opcion=this.opcionCliente;
        console.log(this.cabecera);
        this.siniestralidadService.exportarSiniestralidadVAMEmpresa(this.cabecera).subscribe(excel => {
            var  a  =  document.createElement("a");
            document.body.appendChild(a);
            a.className  =  "hidden"
            let  fileBlob  = excel.blob();
            let  blob  =  new  Blob([fileBlob], {
                type:  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            });
            let  url  =  window.URL.createObjectURL(blob);
            a.href  =  url;
            a.download  = "DetalleSiniestralidad.xlsx";
            if  (window.navigator  &&  window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveOrOpenBlob(blob,  "DetalleSiniestralidad.xlsx");
            }
            else  {
                a.click();
                window.URL.revokeObjectURL(url);
            }
            this.showLoader  =  "";
        }, error => {
            this.showLoader = "";
            swal({
                title: 'Error al exportar siniestralidad',
                text: error,
                type: 'error',
                confirmButtonColor: '#A14950',
                confirmButtonText: 'Aceptar'
            });
            console.log(error)
        })
    }
}


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/empresas/polizasContratadas/siniestralidad.component.ts